import React from "react";
import { Card, CardContent } from "@/components/ui/card";

export default function DashboardPixelAudit({ pixelAudit, restaurant }) {
  if (!pixelAudit || !restaurant?.integrations?.facebook_pixel_id) return null;
  return (
    <Card className={`border-2 ${pixelAudit.critical ? "border-red-400 bg-red-50/30" : pixelAudit.alert ? "border-amber-400 bg-amber-50/30" : "border-blue-200 bg-blue-50/20"}`}>
      <CardContent className="p-4">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-2">
            <span className="text-lg">{pixelAudit.critical ? "🚨" : pixelAudit.alert ? "⚠️" : "✅"}</span>
            <div>
              <p className="font-bold text-sm">Facebook Pixel — Auditoria (30 dias)</p>
              <p className="text-xs text-muted-foreground">
                {pixelAudit.critical
                  ? "Purchase sem pedido real detectado — verificar duplicação"
                  : pixelAudit.alert
                  ? `Divergência de ${pixelAudit.divergence_pct}% entre eventos Pixel e pedidos pagos`
                  : "Pixel sincronizado com pedidos reais"}
              </p>
            </div>
          </div>
          <div className="flex gap-4 text-center text-xs">
            <div>
              <p className="font-bold text-base text-emerald-600">{pixelAudit.real_orders}</p>
              <p className="text-muted-foreground">Pedidos pagos</p>
            </div>
            <div>
              <p className="font-bold text-base text-blue-600">{pixelAudit.capi_events}</p>
              <p className="text-muted-foreground">Eventos CAPI</p>
            </div>
            <div>
              <p className="font-bold text-base text-indigo-600">{pixelAudit.browser_events}</p>
              <p className="text-muted-foreground">Eventos Browser</p>
            </div>
            <div>
              <p className={`font-bold text-base ${pixelAudit.divergence_pct > 15 ? "text-red-600" : "text-gray-700"}`}>
                {pixelAudit.divergence_pct}%
              </p>
              <p className="text-muted-foreground">Divergência</p>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
